var map = {
	"./DatabasesModule.vue": [
		"dd72",
		"chunk-15a6ac8c"
	],
	"./DigitalHoldingsModule.vue": [
		"249a",
		"chunk-0115baac"
	],
	"./FacilitiesModule.vue": [
		"6759",
		"chunk-7627b75f"
	],
	"./PrintHoldingsModule.vue": [
		"4832",
		"chunk-552183dd"
	],
	"./SettingsModule.vue": [
		"fe48",
		"chunk-1b550598"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5563";
module.exports = webpackAsyncContext;